import Link from "next/link";
import Image from "next/image";

interface Product {
  id: string;
  title: string;
  handle: string;
  description: string;
  images: {
    edges: Array<{
      node: {
        id: string;
        url: string;
        altText: string;
      };
    }>;
  };
  priceRange: {
    minVariantPrice: {
      amount: string;
      currencyCode: string;
    };
  };
  variants: {
    edges: Array<{
      node: {
        id: string;
        availableForSale: boolean;
      };
    }>;
  };
}

interface ProductCardProps {
  product: Product;
}

export const ProductCard = ({ product }: ProductCardProps) => {
  const mainImage = product.images.edges[0]?.node;

  const isAvailable = product.variants.edges.some(
    (edge) => edge.node.availableForSale
  );

  return (
    <Link href={`/shop/product/${product.handle}`} prefetch={false}>
      <div className="cursor-pointer group">
        <div className="aspect-square relative bg-gray-100 overflow-hidden mb-4 rounded-lg">
          {mainImage ? (
            <Image
              src={mainImage.url}
              alt={mainImage.altText || product.title}
              fill
              className="object-cover group-hover:scale-105 transition-transform duration-300"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-gray-400">
              <span>No Image</span>
            </div>
          )}
          {!isAvailable && (
            <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
              <span className="text-white font-semibold">Sold Out</span>
            </div>
          )}
        </div>

        <div className="space-y-2 flex flex-col">
          <h3 className="font-semibold text-xl text-gray-800">
            {product.title}
          </h3>

          <span className="text-2xl font-light text-gray-900">
            ${product.priceRange.minVariantPrice.amount}
          </span>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
